export default function LegacySiteFrame({ children, className = "" }) {
  return <div className={`relative z-10 w-full max-w-[1100px] mx-auto bg-brand-surface shadow-2xl min-h-screen flex flex-col ${className}`}>{children}</div>;
}
